import React from 'react'
import useStyles from './style'
import { Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'

const Footer = ({contactVisible = true}) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const contactDetails = useSelector(
    (state) => state?.contactDetailsReducer?.contactDetails?.contactDetails
  )
  const stores = useSelector(
    (state) => state?.contactDetailsReducer?.contactDetails?.stores
  )
  const phoneNumber = `91${contactDetails?.whatsappNo}` || ''
  const message = 'Send hi to start'

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

  return (
    <>
      {!contactVisible ? null : <Grid container className={classes.root}>
        <Grid item xs={12}>
          <section className={classes.wrapper}>
            <Grid item xs={12} sm={4} md={3} className={classes.list}>
              <div className={classes.title}>
                <Typography variant="h6">
                  <img
                    src="/assets/images/link.png"
                    alt="link"
                    className={classes.labelIconImg}
                  />{' '}
                  Quick Links
                </Typography>
              </div>
              <div className={classes.label}>
                <Typography variant="h6" onClick={() => navigate(`/shop/all`)}>
                  All Jewellery
                </Typography>
              </div>
              <div className={classes.label}>
                <Typography variant="h6" onClick={() => navigate(`/shop/gold`)}>
                  Gold
                </Typography>
              </div>{' '}
              <div className={classes.label}>
                <Typography
                  variant="h6"
                  onClick={() => navigate(`/shop/silver`)}
                >
                  Silver
                </Typography>
              </div>{' '}
            </Grid>

            <Grid item xs={12} sm={4} md={3} className={classes.list}>
              <div className={classes.title}>
                <Typography variant="h6">
                  <img
                    src="/assets/images/contact1.png"
                    alt="link"
                    className={classes.labelIconImg}
                  />
                  Contact Us
                </Typography>
              </div>
              <div
                style={{
                  paddingBlockEnd: 12,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <img
                  src="/assets/images/email.png"
                  alt="link"
                  className={classes.labelIconImg}
                />
                <a
                  href={`mailto:${contactDetails?.email}`}
                  className={classes.labelLink}
                >
                  {contactDetails?.email}
                </a>
              </div>
              <div
                style={{
                  paddingBlockEnd: 12,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <img
                  src="/assets/images/phone.png"
                  alt="link"
                  className={classes.labelIconImg}
                />
                <a
                  href={`tel:+91${contactDetails?.mobileNo}`}
                  className={classes.labelLink}
                >
                  +91{contactDetails?.mobileNo || ''}
                </a>
              </div>{' '}
            </Grid>

            <Grid item xs={12} sm={4} md={3.5} className={classes.list}>
              <div className={classes.title}>
                <Typography variant="h6">
                  <img
                    src="/assets/images/shop.png"
                    alt="shop"
                    className={classes.labelIconImg}
                  />
                  Stores
                </Typography>
              </div>
              <div className={classes.label}>
                <Typography
                  variant="h6"
                  onClick={() =>
                    window.open(contactDetails?.homeBranchMapLink, '_blank')
                  }
                >
                  - {contactDetails?.homeBranchAddress || ''}
                </Typography>
              </div>
              {/* {!_.isEmpty(stores) && (
                <div className={classes.label}>
                  <Typography variant="h6">
                    <strong>Branches</strong>
                  </Typography>
                </div>
              )} */}
              {stores?.map((data) => (
                <div className={classes.label}>
                  <Typography
                    variant="h6"
                    onClick={() => window.open(data?.mapLink, '_blank')}
                  >
                    - {data?.address || ''}
                  </Typography>
                </div>
              ))}

              <div className={classes.linkWrapper}>
                <img
                  src="/assets/images/social/facebook.png"
                  alt="facebook"
                  className={classes.socialIcons}
                  onClick={() => window.open(contactDetails?.fburl, '_blank')}
                />
                <img
                  src="/assets/images/social/instagram.png"
                  alt="instagram"
                  className={classes.socialIcons}
                  onClick={() =>
                    window.open(contactDetails?.instaurl, '_blank')
                  }
                />
                <img
                  src="/assets/images/social/whatsapp.png"
                  alt="whatsapp"
                  className={classes.socialIcons}
                  onClick={() => window.open(url, '_blank')}
                />
              </div>
            </Grid>
          </section>
        </Grid>
      </Grid>}
      <section className={classes.copyright}>
        <Typography variant="body2">
          &#169; {moment().format('YYYY')} M8 IT Solutions Pvt Ltd. All rights
          reserved.
        </Typography>
      </section>
    </>
  )
}

export default Footer
